// @flow

import * as React from 'react';
import classnames from 'classnames';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './RightSidebar.css';

type Props = {
  children: any,
  isOpen: boolean,
  onToggle: () => void,
  width?: number
}

export default class RightSidebar extends React.PureComponent<Props> {

  static defaultProps = {
    width: 280
  };

  renderToggleButton = () => {
    const { isOpen, onToggle } = this.props;

    console.log('[RightSidebar] renderToggleButton called', { isOpen });

    return (
      <button
        onClick={() => {
          console.log('[RightSidebar] Toggle button clicked', { currentIsOpen: isOpen });
          onToggle();
        }}
        className={styles.toggleButton}
        aria-label="Toggle sidebar"
      >
        {isOpen ? <CloseOutlined /> : <MenuOutlined />}
      </button>
    );
  };

  componentDidMount() {
    console.log('[RightSidebar] Component mounted', {
      isOpen: this.props.isOpen,
      width: this.props.width,
      hasOnToggle: !!this.props.onToggle,
      hasChildren: !!this.props.children
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      console.log('[RightSidebar] isOpen changed', {
        from: prevProps.isOpen,
        to: this.props.isOpen
      });
    }
  }

  render() {
    const { children, isOpen, width } = this.props;

    console.log('[RightSidebar] render called', {
      isOpen,
      width,
      sidebarClass: styles.sidebar,
      openClass: styles.open,
      hasChildren: !!children
    });

    const sidebarStyle = {
      width: `${width}px`,
    };

    const computedClassName = classnames(styles.sidebar, { [styles.open]: isOpen });
    console.log('[RightSidebar] Computed className:', computedClassName);
    console.log('[RightSidebar] Inline style:', sidebarStyle);

    return (
      <div
        className={computedClassName}
        style={sidebarStyle}
      >
        <button
          onClick={this.props.onToggle}
          className={styles.closeButton}
          aria-label="Close sidebar"
        >
          <CloseOutlined />
        </button>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    );
  }
}
